import { render, staticRenderFns } from "./profiles-list-v2.vue?vue&type=template&id=05ee125a"
import script from "./profiles-list-v2.vue?vue&type=script&lang=js"
export * from "./profiles-list-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLoader: require('/app/components/ui/c-loader.vue').default,IconCalendarCheck: require('/app/components/v2/icons/IconCalendarCheck.vue').default})
